import * as React from "react";

const SmileyColorIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      fill="#3B82F6"
      d="M8.5 1.5A6.5 6.5 0 1 0 15 8a6.507 6.507 0 0 0-6.5-6.5ZM6.25 6a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm5.183 3.75C10.789 10.862 9.72 11.5 8.5 11.5c-1.22 0-2.29-.637-2.932-1.75a.5.5 0 1 1 .865-.5c.466.807 1.2 1.25 2.067 1.25.867 0 1.6-.444 2.068-1.25a.499.499 0 1 1 .865.5ZM10.75 7.5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
    />
  </svg>
);
export default SmileyColorIcon;
